import styled from 'styled-components'

import { helpers, toRem } from 'styles'

export const Subtitle = styled.div`
	font-size: ${helpers.font.size.caption};
	color: ${helpers.color.textMuted};
	line-height: ${toRem(20)};
`
